import { render, staticRenderFns } from "./ChartTitle.vue?vue&type=template&id=20b05afa"
import script from "./ChartTitle.vue?vue&type=script&lang=js"
export * from "./ChartTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports